<template>
  <div class="prolong-rules main__light_green black--text pt-6">
    <div class="prolong-rules__title h4-headline pb-3 px-0">
      {{ $t('Tenders.SelectExtensionRule') }}
    </div>
    <sRadioGroup
      v-model="model"
      class="prolong-rules__radio-group width-100 "
      data-qa="prolong-rules-radio-group">
      <sRadio
        v-for="item in prolongation_rules"
        :key="item[rule_key]"
        class=" prolong-rule secondary__green_chosen rounded-lg d-flex width-100 pa-4 mb-3 mt-0"
        data-qa="prolong-rules-radio"
        :label="item[rule_key]"
        :value="item[rule_key]">
        <slot
          :item="item"
          name="label">
          <div
            class="prolong-rule-title h5-headline black--text  mb-2"
            data-qa="prolong-rules-radio-title">
            <slot
              :item="item"
              name="title">
              {{ item.title || item.name || $t('Common.NoData') }}
            </slot>
          </div>
          <div class="prolong-rule-description">
            <slot
              data-qa="prolong-rules-radio-description"
              :item="item"
              name="description">
              <div>
                {{ $t('Tenders.TenderOpeningHours') }} {{ item.startTimeNextDay }} - {{ item.endTimeCurrentDay }}
              </div>
              <div>
                <span>{{ item.event === 1 ? $t('Tenders.ByChangingBestPrice') : $t('Tenders.ByNewBid') }}</span>
                <span> {{ item.timeByEnd }} {{ $t('Tenders.ProlongTender') }}  {{ item.duration }} {{ $t('Tenders.Min') }}</span>
              </div>
            </slot>
          </div>
        </slot>
      </sRadio>
    </sRadioGroup>
  </div>
</template>

<script>
export default {
  name: 'prolongRulesRadio',
  props: {
    value: {
      type: [String, Number],
    },
    prolongation_rules: {
      type: Array,
      required: true
    },
    rule_key: {
      type: String,
      default: 'code'
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      }
    }
  }
}
</script>

<style lang="scss">
.prolong-rules {
  .prolong-rule.s-radio {
    white-space: normal;
    .s-radio__label {
      max-width: 100%;
    }
    .s-radio__input {
      position: relative;
      top: 5px;
    }
     &:before {
      top: 25px !important;
      left: 23px !important;
    }
    &:hover:before {
      top: 10px !important;
      left: 4px !important;
    }
  }
}
</style>
